// utility to sleep for certain time
export default ms => new Promise(resolve => setTimeout(() => resolve(ms), ms))
